import { render, staticRenderFns } from "./ReverterComissao.vue?vue&type=template&id=1edc3938&"
import script from "./ReverterComissao.vue?vue&type=script&lang=ts&"
export * from "./ReverterComissao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports